import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';

// Statically import the language-specific components for better SEO.
import CookiePolicyEN from './en/CookiePolicy';
import CookiePolicyHE from './he/CookiePolicy';

const CookiePolicy = () => {
  const lang = useLanguage();

  let LanguageSpecificComponent;

  switch (lang) {
    case 'he':
      LanguageSpecificComponent = CookiePolicyHE;
      break;
    case 'en':
    default:
      LanguageSpecificComponent = CookiePolicyEN;
      break;
  }

  return <LanguageSpecificComponent />;
};

export default CookiePolicy;
